import { NormalizeInfoMinMaxHelper } from './rate-terms-notes.types';

export const normalizeInfoMinMaxHelper: NormalizeInfoMinMaxHelper =
  (rateTerms) => (requiredTimeType, label) => {
    if (!rateTerms) return null;

    return rateTerms[requiredTimeType]
      ? {
        // TODO: remove eslint disable
        // eslint-disable-next-line @typescript-eslint/no-base-to-string,@typescript-eslint/restrict-template-expressions
          [requiredTimeType]: `${rateTerms[requiredTimeType]} ${label}`,
        }
      : { [requiredTimeType]: '' };
  };
